import React from "react";

import { notification } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { IconClose, IconError, IconSuccess } from "../../../assets/icon";
const Notify = ({
  type = "success",
  title,
  content,
  placement = "topRight",
  reset,
  isNotify,
}) => {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const openNotificationWithIcon = () => {
    api[type ? type : "success"]({
      message: t(""),
      description: t(content),
      icon: type === "error" ? <IconError /> : <IconSuccess />,
      closeIcon: <IconClose />,
    });
  };
  useEffect(() => {
    if (isNotify) {
      openNotificationWithIcon();
    }
    let isSetTimeOut = setTimeout(() => {
      dispatch(reset());
    }, 1500);
    return () => {
      clearTimeout(isSetTimeOut);
    };
  }, [isNotify]);
  return <>{contextHolder}</>;
};
export default Notify;
